<template>
  <!-- 會議通知單 列印頁 -->
  <div id="PrintAssembly_main">
    <div
      ref="printPage"
      class="printPage"
    >
      <div>
        <p class="title">
          {{ data.title }}
        </p>
        <p
          id="title"
          class="title"
        >
          開會通知單
        </p>
        <p
          v-if="data.issueTextNumber"
          class="tip"
        >
          發文字號：{{ data.issueTextNumber }}
        </p>
      </div>
      <table
        class="printAssembly_table"
        aria-describedby="title"
      >
        <tbody>
          <tr>
            <th scope="row">
              會議類型
            </th>
            <td>
              <span v-if="data.category === 'Regular'">定期會議</span>
              <span v-if="data.category === 'Extraordinary'">臨時會議</span>
            </td>
          </tr>
          <tr>
            <th scope="row">
              會議時間
            </th>
            <td>
              <span v-if="data.assemblyStartAt">{{ data.assemblyStartAt.slice(0, 10) }} {{ data.assemblyStartAt.slice(-8, -3) }}</span>
              <span v-if="data.assemblyDueAt && data.assemblyDueAt != `0001-01-01T00:00:00`"> ~ {{ data.assemblyDueAt.slice(-8, -3) }}</span>
            </td>
          </tr>
          <tr v-if="data.place">
            <th scope="row">
              會議地點
            </th>
            <td>{{ data.place.name }}</td>
          </tr>
          <tr v-if="data.place">
            <th scope="row">
              會議地址
            </th>
            <td>{{ data.place.address }}</td>
          </tr>
          <tr v-if="data.host">
            <th scope="row">
              會議召集人
            </th>
            <td>{{ data.host.name }}</td>
          </tr>
          <tr v-if="data.contactPerson">
            <th scope="row">
              聯絡人
            </th>
            <td>{{ data.contactPerson.name }}</td>
          </tr>
          <tr>
            <th scope="row">
              會議程序
            </th>
            <td>
              <div
                class="description"
                v-html="data.cleanDescription"
              />
            </td>
          </tr>
          <tr>
            <th scope="row">
              投票議案
            </th>
            <td class="topicList">
              <p
                v-for="(item, index) in topicList"
                :key="index"
              >
                <br v-if="index != 0">
                {{ item.title }}
              </p>
            </td>
          </tr>
          <tr>
            <th scope="row">
              備註
            </th>
            <td>
              <div class="note">
                {{ data.note }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <p class="today">
        中華民國 {{ day }}
      </p>
    </div>
  </div>
</template>
<script>
import * as DOMPurify from 'dompurify'
export default {
  data () {
    return {
      data: {},
      topicList: [],
      day: ''
    }
  },
  methods: {
    // 先取得會議資料再列印
    getAssembly (assemblyId) {
      this.fullScreenLoading(true)
      apiUnitOwnerAssembly.Assembly.GetAssembly(
        {
          AssemblyId: assemblyId
        }
      ).then(res => {
        console.log(res)
        this.data = res.data
        this.data.cleanDescription = DOMPurify.sanitize(this.data.description, { USE_PROFILES: { html: true } })
        this.date()
        this.loading = false
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
      apiUnitOwnerAssembly.Topic.GetTopicList(
        {
          AssemblyId: assemblyId
        }
      ).then(res => {
        this.topicList = res.data
        this.loading = false
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
      setTimeout(() => {
        this.fullScreenLoading(false)
        this.$print(this.$refs.printPage)
      }, 300)
    },
    date () {
      const fullDate = new Date()
      const ROCyear = fullDate.getFullYear() - 1911
      this.day = `${ROCyear} 年 ${('0' + (fullDate.getMonth() + 1)).slice(-2)} 月 ${('0' + fullDate.getDate()).slice(-2)} 日`
    },
    // 列印
    print (data, topicList) {
      this.fullScreenLoading(true)
      this.topicList = topicList
      this.data = data
      this.date()
      console.log(data)
      setTimeout(() => {
        this.fullScreenLoading(false)
        this.$print(this.$refs.printPage)
      }, 300)
    },
    fullScreenLoading (display) {
      const loadingWrap = this.$loading({
        lock: true,
        text: '資料處理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      if (!display) { loadingWrap.close() }
    }
  }
}
</script>
<style lang="sass" scoped>
#PrintAssembly_main
  .printPage
    display: none
    .printAssembly_table
      td,th
        border: #000 1px solid
        padding: 10px
</style>
<style lang="sass" scoped>
@media print
  *
    -webkit-print-color-adjust: exact
  .printPage
    display: block
    color: $black
    width: 100%
    @page
      size: A4 portrait
    .title
      font-size: 30px
      font-weight: bold
      line-height: 40px
      text-align: center
      word-wrap: break-word
    .tip
      text-align: right
      line-height: 30px
    .printAssembly_table
      table-layout: fixed
      width: 100%
      tbody
        width: 100%
        tr
          width: 100%
          td, th
            word-wrap: break-word
            border: #000 1px solid
            padding: 12px
            &:nth-child(1), th
              width: 15%
              min-width: 80px
            &:nth-child(2)
              width: 85%
              .description
                html, body, div, span, applet, object, iframe,
                h1, h2, h3, h4, h5, h6, p, blockquote, pre,
                a, abbr, acronym, address, big, cite, code,
                del, dfn, em, img, ins, kbd, q, s, samp,
                small, strike, strong, sub, sup, tt, var,
                b, u, i, center,
                dl, dt, dd, ol, ul, li,
                fieldset, form, label, legend,
                article, aside, canvas, details, embed,
                figure, figcaption, footer, header, hgroup,
                menu, nav, output, ruby, section, summary,
                time, mark, audio, video
                  margin: revert
                  padding: revert
                  border: revert
                  font-size: revert
                  font: revert
                  vertical-align: revert
              &.topicList
                p
                  width: 100%
                  word-wrap: break-word
              .note
                width: 100%
                box-sizing: border-box
                word-wrap: break-word
                white-space: pre-wrap
    .today
      text-align: center
      line-height: 40px
</style>
